<template>
  <div id="head">
    <div id="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PanelBlue"
  }
</script>

<style scoped>
  #head {
    background: #e0edf8;
    border-radius: 0 0 5px 5px;
    padding: 20px;
    font-size: 100%;
    font-style: normal;
    vertical-align: baseline;
    text-align: left;
  }

  #content {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-style: normal;
    outline: 0;
    display: block;
    color: #000;
  }
</style>

